<app-custom-grid [columns]="columns"
                 [items]="items"
                 [showActions]="true"
                 [disableActions]="readonly"
                 [actions]="actions"
                 [toolbarActions]="toolbarActions"
                 [selectable]="selectableSettings"
                 [showSelectAll]="true"
                 [selectedKeys]="selectedIncidentsId"
                 [selectCallback]="onSelectionChange"
                 [pageable]="true"
                 [pageSizes]="true"
                 [filterable]="true">
</app-custom-grid>

<!--<ng-template #labelColumn let-dataItem>
  <app-labels-badge [labels]="dataItem.labels"></app-labels-badge>
</ng-template>-->
